<template>
    <div>

        <div v-if="groupHasOnlyOneCourse">
            <CourseItem :course="courses[0]"></CourseItem>
        </div>
        <div v-else>
            <div class="rounded bg-grey_3 pa-3 course_item bordered" v-if="firstCourse">
                <div class="text-h6 font-weight-bold">
                    {{ groupName }}
                    <span class="text-h6 font-weight-bold text-darkblue">
                        <span class="text-primary-dark"> | </span>

                        <span
                            v-if="firstCourse.metadatas.discipline != 'Non sportif' && firstCourse.date_depart != '0000-00-00'">
                            Départ
                            : </span>
                        <span
                            v-if="firstCourse.metadatas.discipline != 'Non sportif' && firstCourse.date_depart != '0000-00-00'"
                            class="text-darkblue" style="text-transform: capitalize">
                            {{ $moment(firstCourse.date_depart).format("dddd DD MMMM") }}

                        </span>
                        <span v-if="firstCourse.heure_depart != '00:00:00'"> à {{
                            firstCourse.heure_depart }}</span>
                    </span>
                </div>
                <CourseProperties :course="firstCourse"></CourseProperties>
                <div v-if="firstCourse.metadatas.indications" class="font-italic"
                    v-html="firstCourse.metadatas.indications">
                </div>
                <div class="d-flex justify-space-between flex-wrap flex-md-nowrap gap my-3 border-bottom"
                    v-for="course in courses" :key="course.id">
                    <div>
                        <h4 class="font-weight-bold">
                            {{ course.nom }}
                        </h4>
                        <TarifsCourse :tarifs="course.tarifs" :course="course" oneLined="1"></TarifsCourse>
                    </div>

                    <div class="d-flex flex-column flex-start content_course_item">
                        <!-- Bouton _s'inscrire_ de préselection -->

                        <div v-if="show_inscription_button(course)">
                            <v-btn class="inscription_btn shadowed" color="dark-green" size="default" variant="tonal"
                                @click="addToPreselection(course)">
                                <v-icon icon="mdi-arrow-right-bold" class="mr-2"></v-icon>
                                S'inscrire
                            </v-btn>
                            <!-- Section tarif de la course -->

                        </div>

                        <!-- Bouton disabled si les inscriptions sont closes -->
                        <div v-else>
                            <v-btn v-if="mainStore.module.status == 'avant_ouverture'" class="shadowed" color="dark-red"
                                size="small" variant="tonal"><v-icon icon="mdi-pencil-off-outline"></v-icon> Ouverture à
                                venir</v-btn>
                            <v-btn v-else-if="course.is_complet(all_courses)" class="shadowed" color="dark-red"
                                size="small" variant="tonal"><v-icon icon="mdi-pencil-off-outline"></v-icon> course
                                complète</v-btn>
                            <v-btn v-else-if="mainStore.module.is_complet" class="shadowed" color="dark-red"
                                size="small" variant="tonal"><v-icon icon="mdi-pencil-off-outline"></v-icon> course
                                complète</v-btn>
                            <v-btn v-else class="shadowed" color="dark-red" size="small" variant="tonal"><v-icon
                                    icon="mdi-pencil-off-outline"></v-icon> Inscriptions closes</v-btn>
                        </div>
                    </div>

                </div>
            </div>
        </div>


    </div>
</template>

<script>
import CourseItem from "@/components/Home/Courses/Course_Item.vue";
import CourseProperties from "@/components/Home/Courses/Course_Properties.vue";
import TarifsCourse from "@/components/Home/Courses/Tarifs_Course.vue";
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
    components: { CourseItem, CourseProperties, TarifsCourse },
    props: {
        courses: {
            type: Array,
            required: true
        },
        groupName: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapStores(useMainStore),
        firstCourse() {
            if (this.courses.length === 0) {
                return null;
            }
            if (this.courses[0] && this.courses[0].id) {
                return this.courses[0];
            }

            return null;
        },
        groupHasOnlyOneCourse() {
            return this.courses.length === 1;
        },
    },
    methods: {
        show_inscription_button(course) {

            const course_selectionable = course.is_selectionnable(
                this.mainStore.module.status,
                this.mainStore.view_as_admin,
                this.mainStore.inscription_as_admin,
                this.mainStore.inscription_vip,
                this.mainStore.module.courses,
                this.mainStore.module.is_complet,

                this.mainStore.bookingSystem?.groupe
            );

            return course_selectionable;
        },
        /* Si clic sur button _s'inscrire_ on ajoute en mémoire la préselection pour l'ajouter à la sélection de parcours du premier coureur en page suivante */
        async addToPreselection(course) {
            this.mainStore.requestInscriptionAccess(() => {
                this.mainStore.bookingSystem.preselection = { type: "course", value: course.id, course: course };
                this.$router.push({ name: "Inscriptions" });
            });
        },
    }
}

</script>

<style lang="scss" scoped></style>